import React, { useRef } from 'react'
import Slider from "react-slick";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import './AchCarousal.css'
import AchCard from './AchCard';

function AchCarousal({ imgAch }) {

    const sliderRef = useRef();
    
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        fade: false,
        pauseOnHover: true,
        adaptiveHeight: true
    };

    const gotoNext = () => {
        sliderRef.current.slickNext();
    }

    const gotoPrev = () => {
        sliderRef.current.slickPrev();
    }


  return (
        <div className='achCarousal'>
            <IoIosArrowBack onClick={gotoPrev} className='achSlider__prev'/>
            <div className='achCarousal__slider'>
                <Slider {...settings} ref={sliderRef}>
                    {imgAch && imgAch.map((ach) => (
                        <AchCard 
                            key={ach._id}
                            title={ach.title}
                            description={ach.description}
                            image={ach.image.url}
                        /> 
                    ))}
                </Slider>
            </div>
            <IoIosArrowForward onClick={gotoNext} className='achSlider__next'/>
        </div>
    )
}

export default AchCarousal